import { resolveAuthEmail, normalizeGmailEmail } from "./gmailScope";

/**
 * HARD allowlist — Security Session Manager is only for these accounts.
 * Super Admin / Admin role alone is NOT enough.
 * Must match backend securitySessions/lib/securityAllowlist.js
 */
export const SECURITY_ADMIN_ALLOWLIST = new Set([
  "info@flex.al",
  "lorin@flex.al",
]);

export function normalizeSecurityEmail(value) {
  return normalizeGmailEmail(value);
}

export function canAccessSecurityConsole(authOrUser) {
  return SECURITY_ADMIN_ALLOWLIST.has(resolveAuthEmail(authOrUser));
}

/** Remove Session Manager routes for non-allowlisted users. */
export function stripSecurityRouteAccess(routeConfig = []) {
  return (Array.isArray(routeConfig) ? routeConfig : []).filter(
    (c) => !String(c?.path || "").includes("/konfigurimet/siguria/sesionet")
  );
}

/** Remove Session Manager from settingsConfig for non-allowlisted users. */
export function stripSecuritySettingsAccess(settingsConfig = []) {
  return (Array.isArray(settingsConfig) ? settingsConfig : []).map(
    (section) => ({
      ...section,
      submenu: Array.isArray(section?.submenu)
        ? section.submenu.filter(
            (row) => !String(row?.to || "").includes("siguria/sesionet")
          )
        : section?.submenu,
    })
  );
}
